module.exports = "/_next/static/images/5fde2201ee6ef84a59f7a1a823061b78-hero-desktop.jpg";